export default __webpack_public_path__ + "static/media/mail.a9deaf9c.svg";